import type { FunctionComponent } from 'react';
import { useMemo, useEffect, useRef } from 'react';

import { createStyleHelper } from '../../../shared/utils/class-names';
import { useProviderIntegration } from '../../util/provider-context';

import styles from './custom-field.module.scss';

const style = createStyleHelper(styles, 'custom-field');

export interface ICustomFieldProps {
    providerId: string;
    name: string;
    integrationId: string;
    onChange: (value: unknown) => void;
}

export const CustomField: FunctionComponent<ICustomFieldProps> = ({
    name,
    integrationId,
    onChange,
    providerId,
}) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const integration = useProviderIntegration();
    const sourceField = useMemo(
        () =>
            integration.getCustomField?.({
                configuration: {
                    userProfileId: 'userProfileId',
                },

                providerId,
                integrationId,
                name,
            }),
        [providerId, name, integration, integrationId],
    );

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        sourceField?.render(ref.current);
        sourceField?.addChangeListener?.(onChange);

        return () => {
            sourceField?.removeChangeListener?.(onChange);
            sourceField?.destroy();
        };
    }, [onChange, sourceField]);

    return <div className={style()} ref={ref}></div>;
};
